const SESSION_ID_PREFIX = 'jsyog.regularExamSessionId.';

function sessionIdKey(paperId: number): string {
  return `${SESSION_ID_PREFIX}${paperId}`;
}

/** Last known `sessionId` for this paper (from dashboard URL) for answer/submit APIs. */
export function getStoredRegularExamSessionId(paperId: number): number | null {
  try {
    const raw = localStorage.getItem(sessionIdKey(paperId));
    if (raw == null || raw === '') return null;
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
  } catch {
    return null;
  }
}

export function setStoredRegularExamSessionId(paperId: number, sessionId: number): void {
  try {
    localStorage.setItem(sessionIdKey(paperId), String(sessionId));
  } catch {
    // ignore
  }
}

/** Clears cached regular-exam session ids (e.g. on logout). */
export function clearRegularExamStartRecords(): void {
  try {
    const toRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k?.startsWith(SESSION_ID_PREFIX)) {
        toRemove.push(k);
      }
    }
    toRemove.forEach((k) => localStorage.removeItem(k));
  } catch {
    // ignore
  }
}
